import { render, staticRenderFns } from "./SysMaintain.vue?vue&type=template&id=264aaaac&scoped=true&"
import script from "./SysMaintain.vue?vue&type=script&lang=ts&"
export * from "./SysMaintain.vue?vue&type=script&lang=ts&"
import style0 from "./SysMaintain.vue?vue&type=style&index=0&id=264aaaac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264aaaac",
  null
  
)

export default component.exports